import React from 'react'
import { Component } from 'react'
import './index.css'

import {SocialLink} from '../SocialLink/index'
import {getMe} from '../../Me.js'

const me = getMe();

export class Footer extends Component { 
    render() {
        return(<div className='nanoFooter'>
            <div className='nanoFooterSocial'>
                <div className='nanoFooterSocialLinks'>
                    {me.getSocialLinks().map((lnk, i) => {
                        return <div key={i}><SocialLink nlink={lnk.name} nImage={lnk.media} nUrl={lnk.url} /></div>
                    })}
                </div>
                <div className='nanoFooterAddress'>
                    Badnano Corporation | Califonia, USA
                </div>
            </div>
        </div>);
    }

    componentDidMount() {
        // dom node created
    }

    componentWillUnmount () {
        // dom node deleted
    }

    componentDidUpdate(previousProps, previousState) {
        
    }
}

Footer.defaultProps = {
    title: "nanoFooter"
}
